export const SET_FLAG = 'flags/SET_FLAG'
export const SET_FLAG_STARTED = 'flags/SET_FLAG_STARTED'
export const SET_FLAG_SUCCESS = 'flags/SET_FLAG_SUCCESS'
export const SET_FLAG_FAILED = 'flags/SET_FLAG_FAILED'
